import React, { useState } from "react";
import { FaCamera } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import profileImage from "../assets/cait.png";
import { updateUserImageUrl } from "../redux/user/userSlice";
import ToastNotification from "../utils/toastNotification";

export default function CircularImageWithCaption({ title }) {
  const [selectedImage, setSelectedImage] = useState(null);
  const { user } = useSelector((state) => state.user);
  const dispatch = useDispatch(); // Obtiene la función dispatch
  const [showToast, setShowToast] = useState(false);

  const handleCameraClick = () => {
    document.getElementById("fileInput").click();
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setSelectedImage(file);

    // Subir la imagen al servidor
    const formData = new FormData();
    formData.append("image", file);
    formData.append("userId", user.id);

    fetch("https://server-postgre.vercel.app/upload", {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        dispatch(updateUserImageUrl(data.imageUrl));
        setShowToast(true);
      })
      .catch((error) => {
        console.error("Error al subir la imagen:", error);
      });
  };

  const closeToast = () => {
    setShowToast(false);
  };

  return (
    <div
      className="relative flex flex-col pt-5 items-center rounded-lg overflow-hidden border-3 border-white"
      style={{
        background: "linear-gradient(135deg, #d8d8d8, #007bff, #ffffff)",
        maxWidth: "300px", // Establecer el ancho máximo a 300px
        width: "100%", // Asegurar que el contenedor se ajuste al ancho máximo
        height: "65vh", // Establecer la altura al 65% del viewport height
      }}
    >
      {selectedImage ? (
        <img
          src={URL.createObjectURL(selectedImage)}
          alt="Selected"
          className="rounded-full h-56 w-56 mb-20 bg-slate-200 relative z-10"
          style={{ border: "3px solid white" }}
        />
      ) : (
        <label htmlFor="fileInput">
          <img
            src={
              user.url_image
                ? `https://server-postgre.vercel.app/${user.url_image}`
                : profileImage
            }
            alt="Placeholder"
            className="rounded-full h-56 w-56 mb-20 bg-slate-200 relative z-10 cursor-pointer"
            style={{ border: "3px solid white" }}
          />
        </label>
      )}
      <input
        id="fileInput"
        type="file"
        accept="image/*"
        className="hidden"
        onChange={handleImageChange}
      />
      <FaCamera
        className="absolute top-56 right-24 text-gray-700 cursor-pointer z-20"
        size={24}
        onClick={handleCameraClick} // Abre la ventana de selección de imagen al hacer clic en el ícono de la cámara
      />
      <h2 className="text-2xl font-bold text-white">{title}</h2>
      {showToast && (
        <ToastNotification
          message="Imagen subida con éxito"
          onClose={closeToast}
        />
      )}
    </div>
  );
}
